import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ApStudentDetailsModel } from '../../global/components/student_details/models/ap_student_details_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'commitSuggestedPlanCommand',
    function commitSuggestedPlanCommand(
      $http: ng.IHttpService,
      log: any,
      defineCommand: IDefineCommand,
      ngApStudentDetailsModel: ApStudentDetailsModel
    ) {
      return defineCommand('commitSuggestedPlanCommand', (deferred: any, commentMessage: string, planId: number) => {
        $http
          .post(`/academicplan/suggested_plan/${planId}/commit`, {
            comment: {
              message: commentMessage,
              recipient: ngApStudentDetailsModel.read().user_id
            }
          })
          .then((response: any) => {
            deferred.resolve(response);
          })
          .catch((error: any) => {
            log.disable();
            deferred.reject(error);
            log.enable();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/commands/commit_suggested_plan_command.ts